import { render, staticRenderFns } from "./paperclip.vue?vue&type=template&id=132586dc&"
import script from "./paperclip.vue?vue&type=script&lang=js&"
export * from "./paperclip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132586dc')) {
      api.createRecord('132586dc', component.options)
    } else {
      api.reload('132586dc', component.options)
    }
    module.hot.accept("./paperclip.vue?vue&type=template&id=132586dc&", function () {
      api.rerender('132586dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/paperclip.vue"
export default component.exports